/**
 * rounds given float value. By default, precision is 3 digits after comma (enough in most cases)
 * @param value
 * @param precision
 * @returns { number }
 */
export const floatRound = (value, precision = 3) => {
  if (!value) return 0;
  const factor = 10 ** precision;
  return Math.round(value * factor) / factor;
};

/**
 * returns numeric integer parsed out of given value
 * @returns { number }
 * @note if consists of chars returns 0 instead of NaN as Number, +, parseInt
 */
export function toNumericInt(value) {
  return ~~value;
}

/**
 * converts value to number if possible, otherwise returns null
 * @param { any } value
 * @return { null|number }
 */
export const toIntOrNull = value => (value ? +value : null);

/**
 * converts value to number if possible, otherwise returns null
 * @param { any } value
 * @return { null|number }
 */
export function toNumOrNull(value) {
  const num = parseFloat(value);
  return Number.isNaN(num) ? null : num;
}

/**
 * Checks if value is in given range (inclusive)
 * @param { number } value
 * @param { number } min
 * @param { number } max
 * @returns { boolean }
 */
export function inRange(value, min, max) {
  if (!Number.isFinite(value)) {
    return false;
  }
  return value >= min && value <= max;
}

/**
 * Converts decimal fraction to percent
 */
export function fractionToPercent(
  fraction,
  precision = 0,
  addPercentSign = false,
) {
  const percent = (fraction * 100).toFixed(precision);
  return addPercentSign ? `${percent}%` : percent;
}

/**
 * Formats a number as a CHF price string, e.g. "CHF 12.50".
 * Returns "—" for null/undefined values.
 */
export function formatCHF(value) {
  if (value == null) return '—';
  return `CHF ${Number(value).toFixed(2)}`;
}

/**
 * Calculates percent from a given value and total
 */
export function calculatePercent(value, total, precision = 0) {
  if (!parseFloat(value) || !parseFloat(total)) {
    return 0;
  }
  const ratio = total > 0 ? Number(value) / Number(total) : 0;
  return fractionToPercent(ratio, precision);
}
